import { AlertDialogPrompt } from './components';

export { useAlertDialogPrompt } from './components';

export const AlertDialog = {
  Prompt: AlertDialogPrompt,
};
